import { all, put, takeEvery } from 'redux-saga/effects';
import { requestLeaderBoardGet, requestLeaderBoardPost, requestLeaderBoardQuiz } from './api';
import { LEADER_BOARD_GET_SETTINGS, LEADER_BOARD_PUT_SETTINGS, LEADER_BOARD_SETTINGS_QUIZ } from './constants';
import { leaderBoardGetSuccess, leaderBoardPutSuccess, leaderBoardSettingsQuizSuccess } from './actions';


/**
 *
 * @param obj
 * @returns {Generator<SimpleEffect<"PUT", PutEffectDescriptor<{result: *, type: string}>>|*, void, *>}
 */
function* getLeaderBoardGetSettings( obj ) {
    const serverResponse = yield requestLeaderBoardGet( obj.id );
    if ( serverResponse ) {
        yield put( leaderBoardGetSuccess( serverResponse ) );
    }
}

/**
 *
 * @param obj
 * @returns {Generator<Promise<* | void>|SimpleEffect<"PUT", PutEffectDescriptor<{result: *, type: string}>>, void, *>}
 */
function* getLeaderBoardPutSettings( obj ) {
    const serverResponse = yield requestLeaderBoardPost( obj.id, obj.data );
    if ( serverResponse ) {
        yield put( leaderBoardPutSuccess( serverResponse ) );
    }
}

function* getLeaderBoardQuizSettings( obj ) {
    const serverResponse = yield requestLeaderBoardQuiz( obj.param );
    if ( serverResponse ) {
        yield put( leaderBoardSettingsQuizSuccess( serverResponse ) );
    }
}


/**
 *
 * @returns {Generator<SimpleEffect<"FORK", ForkEffectDescriptor<never>>, void, *>}
 */
function* watchGetLeaderBoardSettings() {
    yield takeEvery( LEADER_BOARD_GET_SETTINGS, getLeaderBoardGetSettings );
}

/**
 *
 * @returns {Generator<SimpleEffect<"FORK", ForkEffectDescriptor<never>>, void, *>}
 */
function* watchPetLeaderBoardSettings() {
    yield takeEvery( LEADER_BOARD_PUT_SETTINGS, getLeaderBoardPutSettings );
}

function* watchLeaderBoardQuizSettings() {
    yield takeEvery( LEADER_BOARD_SETTINGS_QUIZ, getLeaderBoardQuizSettings );
}

/**
 *
 * @returns {Generator<CombinatorEffect<"ALL", Generator<SimpleEffect<"FORK", ForkEffectDescriptor<never>>, void, *>>, void, *>}
 */
function* watchLeaderBoardSettings() {
    yield all( [
        watchGetLeaderBoardSettings(),
        watchPetLeaderBoardSettings(),
        watchLeaderBoardQuizSettings()
    ] );
}

export default watchLeaderBoardSettings;
